import { TextField as MUITextField } from "@material-ui/core";
import { AutocompleteProps as MUIAutocompleteProps } from "@material-ui/lab/Autocomplete";
import React from "react";

import { countryToFlag } from "../../../utils/utility";
import { Autocomplete } from "./Autocomplete";

export interface CountryAutocompleteProps extends MUIAutocompleteProps<any, undefined, undefined, undefined> {
  error: any;
  id: string;
  label: React.ReactNode;
  onChange: (value: any) => void;
}

export const CountryAutocomplete = (props: CountryAutocompleteProps) =>
  <Autocomplete
    {...props}
    showIcon={!!props.value}
    getIcon={countryToFlag}
  />
;

CountryAutocomplete.defaultProps = {
  onChange: (value: string) => value,
  showIcon: false,
  renderOption: (option: any) => option.label,
  renderInput: (params: any) => <MUITextField {...params} />,
}
